import { getSpeakerAssignments } from "../services/record.service";

type TranscriptPayload = {
  richResult: unknown;
  hashedResult?: string;
};

// Legacy plain text uses "[S1]:" header lines; only those lines are renamed, never body text.
export function applySpeakerNamesToPlainText(text: string, speakerNames: ReadonlyMap<string, string>): string {
  if (!text || speakerNames.size === 0) return text;
  return text.replace(/^\[([^\]\n]+)\]:/gm, (match, label: string) => {
    const name = speakerNames.get(label.trim());
    return name ? `[${name}]:` : match;
  });
}

export async function loadTranscriptForExport(
  recordId: number,
  fetchTranscript: () => Promise<TranscriptPayload>,
) {
  // Resolve names before fetching a transcript, which may consume a secret download.
  const assignments = await getSpeakerAssignments(recordId);
  const speakerNames = new Map<string, string>();
  assignments.speakers.forEach((speaker) => {
    const name = speaker.contact_name || speaker.custom_name;
    if (name) speakerNames.set(speaker.speaker_label, name);
  });
  const transcript = await fetchTranscript();
  return {
    ...transcript,
    hashedResult: transcript.hashedResult
      ? applySpeakerNamesToPlainText(transcript.hashedResult, speakerNames)
      : transcript.hashedResult,
    speakerNames,
  };
}
